import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from './Icon.svg';
import Badge from './Badge.svg';
import styles from './styles';
import { withParagraphs } from '../../../../utils/strings';
import { useTranslation } from 'react-i18next';

export default function FormFieldHelp({
  name,
  label,
  help,
  showHelp,
  setShowHelp,
}) {
  const { t } = useTranslation();
  const altText = showHelp ? t('Click to close') : null;

  return (
    (help && (
      <div className={styles.help}>
        <Icon onClick={() => setShowHelp(true)} />
        <div
          className={cx(styles.tooltipContainer, {
            [styles.showTooltip]: showHelp,
          })}
          onClick={() => setShowHelp(false)}
          aria-label={altText}
          tooltip={altText}
        >
          <div className={styles.tooltip}>
            <Badge />
            <div className={styles.message}>
              <label
                className={cx(styles.label, styles.helpLabel)}
                htmlFor={name}
              >
                <q>{t(label)}</q>
              </label>
              {withParagraphs(t(help))}
              <button
                className={cx(styles.button, styles.helpButton)}
                onClick={() => setShowHelp(false)}
                type="button"
              >
                {t('OK')}
              </button>
            </div>
          </div>
        </div>
      </div>
    )) ||
    null
  );
}

FormFieldHelp.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  help: PropTypes.string,
  showHelp: PropTypes.bool,
  setShowHelp: PropTypes.func,
};
